"use client";
import Image from "next/image";
import React, { Fragment } from "react";
const styles = new Proxy({"Testimonial":"Testimonial-46c7f","Image":"Image-46c7f","Text":"Text-46c7f"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

export type TestimonialProps = {
  image: { url: string };
  name: string;
  description: { line: string }[];
  quote: string;
};

const Testimonial = ({ image, name, description, quote }: TestimonialProps) => (
  <div className={styles.Testimonial}>
    <div className={styles.Image}>
      <Image src={image.url} alt={`Profile of ${name}`} fill sizes="94px" />
    </div>

    <div className={styles.Text}>
      <h5 className="m-0">{name}</h5>

      <h6>
        {description.map((item, i) => (
          <Fragment key={i}>
            {item.line}
            <br />
          </Fragment>
        ))}
      </h6>

      <span />

      <p>{quote}</p>
    </div>
  </div>
);

export default Testimonial;
